module.exports = __webpack_public_path__ + "static/media/VisualHome.8f0d2eab.jpg";